import { tableFromIPC } from "apache-arrow";
import { rowsFromTable } from "./helpers";

export async function fetchElectoratesBaseline({
  getActiveGroup,
  getFilters,
  getKeyWeightMap,
  setState,
  _tracking,
}) {
  const rawGroup = getActiveGroup();
  const group = rawGroup?.TargetVariable1 || rawGroup;

  if (!group?.keys?.length) {
    setState({ metricRowsElectorates: null });
    return;
  }

  const filters = getFilters();
  const keyWeightMap = getKeyWeightMap?.() ?? null;
  const key = `elec_baseline|${group.keys.join(",")}|${JSON.stringify(filters)}`;
  const now = Date.now();

  if (_tracking.lastKey === key && now - _tracking.lastAt < 700) return;
  _tracking.lastKey = key;
  _tracking.lastAt = now;

  if (_tracking.inflight) _tracking.inflight.abort();
  _tracking.inflight = new AbortController();

  const body = {
    groupKeys: group.keys,
    filters,
    areaCodes: [],
    schema: "nz_single",
    turnout_weight: group.weightCol || "n_raked",
    group_by_wave: Boolean(group.waves?.length),
    ...(keyWeightMap ? { keyWeightMap } : {}),
  };

  try {
    const res = await fetch("/api/electorate_data_arrow/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: _tracking.inflight.signal,
    });
    if (!res.ok) throw new Error(`electorate baseline ${res.status}`);
    const rows = rowsFromTable(tableFromIPC(await res.arrayBuffer()));
    setState({ metricRowsElectorates: rows });
  } catch (e) {
    if (e.name !== "AbortError") console.error("electorate baseline error:", e);
    setState({ metricRowsElectorates: null });
  } finally {
    _tracking.inflight = null;
  }
}
